<template>
  <div class="wrapper mainbg">
    <!-- <reg-banner></reg-banner> -->
    <img :src="websiteBgBanSmall" width="100%" />
    <div class="reg-content clearfix">
      <van-form class="sform" @submit="onSubmit">
        <div class="reg-content-per">
          <div class="reg-card">
            <div class="header">
              编辑
              <div class="txt"><span class="xx">*</span>为必填项</div>
            </div>

            <div class="reg-login reg-card-login">
              <template v-for="(item, index) in inputs">
                <van-field
                  :key="item.code + index"
                  v-model="formvals[item.code]"
                  :label="item.name"
                  :name="item.code"
                  :placeholder="item.holder"
                  :rules="item.code == 'cardNO' ? cardrules : item.rules"
                  v-if="!item.isSelect"
                  :disabled="item.code == 'Mobile'"
                >
                  <!-- <template v-if="item.code == 'VerifyCode'" #button>
                    <div class="reg-field-btn" @click="getVerifyCode">
                      <template v-if="isStart">
                        <van-count-down
                          ref="VerifycountDown"
                          :time="time"
                          :auto-start="false"
                          @finish="finish"
                        >
                          <template #default="timeData">
                            <span class="block">{{ timeData.seconds }}</span
                            >秒后重试
                          </template>
                        </van-count-down>
                      </template>
                      <template v-else> 获取验证码 </template>
                    </div>
                  </template> -->
                </van-field>
                <van-field
                  :key="item.code + index"
                  v-else
                  readonly
                  clickable
                  :name="item.code"
                  :value="formvals[item.code]"
                  :label="item.name"
                  :placeholder="item.holder"
                  @click="showPicker = true"
                  :rules="item.rules"
                />
                <van-popup
                  v-model="showPicker"
                  position="bottom"
                  :key="'pop' + index"
                >
                  <van-picker
                    show-toolbar
                    :columns="columns"
                    @confirm="onConfirm"
                    @cancel="showPicker = false"
                  />
                </van-popup>
              </template>
            </div>
          </div>
        </div>
        <div class="per-btn">
          <van-button
            round
            type="primary"
            color="#009E38"
            @click="goback"
            native-type="button"
            >返回</van-button
          >
          <van-button
            :loading="loadding"
            loading-text="提交中..."
            round
            type="primary"
            color="#009E38"
            native-type="submit"
            :disabled="!showsave"
            >保存</van-button
          >
        </div>
        <div class="phelp">
          <div class="txt">
            参会人信息仅限修改一次，如需再次修改，请电话咨询客服
          </div>
          <div class="txt">咨询电话：400-821-3388</div>
          <div class="txt">
            电子邮箱：<a href="mailto:pfa-service@vnuexhibitions.com.cn"
              >pfa-service@vnuexhibitions.com.cn</a
            >
          </div>
          <div class="txt">
            官方网站：<a target="_blank" href="https://www.petfairasia.com"
              >www.petfairasia.com</a
            >
          </div>
        </div>
      </van-form>
    </div>
  </div>
</template>
<script>
import {
  Form,
  button,
  field,
  CountDown,
  popup,
  picker,
  Toast,
  Dialog,
} from "vant";
import regField from "@/components/simField";
import { IDTypelist, Personal_inputs } from "@/data/config";
import { Personal, getInfo, GetPersonalVerifyCode } from "@/api/user";
import { mapGetters } from "vuex";
import { getUserInfo, setUserInfo, getOpenid } from "@/utils/auth";
import { CheckCard } from "@/utils/checkcard.js";
export default {
  data() {
    return {
      //   value: "",
      columns: ["身份证", "护照", "台胞证", "港澳通行证"],
      showPicker: false,
      loadding: false,
      title: "编辑",
      mobile: "",
      oldvals: {},
      formvals: {
        pkey: "",
        Mobile: "",
        Surname: "",
        Email: "",
        CompanyName: "",
        Position: "",
        cardType: "身份证",
        cardNO: "",
        // VerifyCode: "",
      },
      isStart: false,
      time: 1 * 60 * 1000,
      inputs: Personal_inputs,
      ckey: "",
      showsave: false,
      isfirst: true,
      firstshow: false,
      haveUpdate: false,
      isFirstEdit: true,
    };
  },
  watch: {
    formvals: {
      handler: function (val, oldval) {
        if (this.isFirstEdit) {
          if (this.isfirst) {
            let _this = this.formvals;
            this.showsave =
              _this.Mobile &&
              _this.Surname &&
              _this.Email &&
              _this.CompanyName &&
              _this.Position &&
              _this.cardType &&
              _this.cardNO;
          } else {
            console.log("oldvals", this.oldvals);
            console.log("formvals", this.formvals);
            //对比
            this.showsave = !this.compareObj(this.oldvals, this.formvals);
          }
        }
      },
      deep: true,
    },
  },
  computed: {
    ...mapGetters(["userinfo", "websiteBgBanSmall"]),
    // showsave: function () {
    //   let haveval = true;
    //   let _this = this;
    //   Object.keys(this.formvals).map((t) => {
    //     if (!_this.formvals[t]) {
    //       haveval = false;
    //       return false;
    //     }
    //   });
    //   return false;
    // },
    cardrules: function () {
      return [
        {
          required: true,
          validator: this.cardNOValidator,
          message: "请输入有效证件号码",
        },
      ];
    },
  },
  components: {
    [Form.name]: Form,
    [button.name]: button,
    [field.name]: field,
    [CountDown.name]: CountDown,
    [popup.name]: popup,
    [picker.name]: picker,
    [Dialog.name]: Dialog,
    regField,
  },
  created() {
    document.title = "亚洲宠物展";

    if (this.userinfo) {
      this.formvals.pkey = this.userinfo.FullCardNumber;
      this.ckey = this.userinfo.FullCardNumber;
      this.getCollInfo(this.ckey);
    } else {
      _this.$router.push({
        name: "login",
      });
    }

    // let ckey = this.$route.query.ckey;
    // if (ckey) {
    //   this.ckey = ckey;
    //   this.getCollInfo(ckey);
    // }
  },
  methods: {
    compareObj(oldobj, newobj) {
      return (
        oldobj.pkey == newobj.pkey &&
        oldobj.Mobile == newobj.Mobile &&
        oldobj.Surname == newobj.Surname &&
        oldobj.Email == newobj.Email &&
        oldobj.CompanyName == newobj.CompanyName &&
        oldobj.Position == newobj.Position &&
        oldobj.cardType == newobj.cardType &&
        oldobj.cardNO == newobj.cardNO
      );
    },
    getIsFirst() {
      if (
        this.Mobile &&
        this.Surname &&
        this.Email &&
        this.CompanyName &&
        this.Position &&
        this.cardType &&
        this.cardNO
      ) {
        return true;
      }
      return false;
    },
    cardNOValidator(val) {
      if (this.formvals.Surname && this.formvals.cardType) {
        console.log(this.formvals);
        if (this.formvals.cardType == "身份证") {
          return CheckCard(val, this.formvals.Surname);
        } else {
          return /^[a-zA-z\d]{6,}$/.test(val);
        }
      }
      return false;
    },
    finish() {
      this.isStart = false;
    },
    getVerifyCode() {
      console.log(this.formvals);
      if (!this.formvals.Mobile) {
        Toast("请输入手机号");
        return;
      }
      if (this.isStart == false) {
        this.isStart = true;
        console.log("获取验证码");
        console.log(this.formvals);
        var params = {
          mobile: this.formvals.Mobile,
          openid: "",
        };
        GetPersonalVerifyCode(params)
          .then((res) => {
            if (res.state == "success") {
              Toast("发送短信成功");
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
      this.$nextTick(() => {
        console.log(this.$refs);
        this.isStart && this.$refs.VerifycountDown[0].start();
      });
    },
    async getCollInfo(ckey) {
      let _this = this;
      getInfo({ ckey: ckey })
        .then((res) => {
          console.log(res);
          if (res.state == "success" && res.data) {
            let model = res.data;
            Object.keys(_this.formvals).forEach((key) => {
              _this.formvals[key] = model[key] || _this.formvals[key];
              _this.oldvals[key] = model[key] || _this.formvals[key];
            });
            //是否为第一次
            _this.isfirst = _this.getIsFirst();
            _this.isFirstEdit = model.isFirstEdit;
            if (!_this.isfirst) {
            }
            console.log("isfirst", _this.isfirst);
            console.log("oldvals", _this.oldvals);
            if (model.IDType) {
              Object.keys(IDTypelist).forEach((key) => {
                if (IDTypelist[key] == model.IDType) {
                  _this.formvals.cardType = key;
                  _this.oldvals.cardType = key;
                }
              });
            }
            _this.formvals.cardNO = model.IDNo || "";
            _this.oldvals.cardNO = model.IDNo || "";
          } else {
            _this.$router.push({
              name: "login",
            });
          }
        })
        .catch((err) => {
          // _this.$router.push({
          //   name: "login",
          // });
          console.log(err);
        });
    },
    IdTypeValidator(val) {
      console.log(val);
    },
    onConfirm(value) {
      console.log(value);
      this.formvals.cardType = value;
      this.showPicker = false;
    },
    unBindCard(params) {
      params["isUnBind"] = true;
      Personal(params)
        .then((res) => {
          console.log(res);
          if (res.state === "success") {
            this.$router.push({
              name: "category",
            });
          } else {
            Toast(res.msg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    goback() {
      this.$router.go(-1);
    },
    async onSubmit(values) {
      console.log("vaules", values);
      values.cardType = IDTypelist[values.cardType];
      console.log(this.userinfo);
      let params = { fullCardNumber: this.ckey, ...values };
      params["isUnBind"] = false;
      console.log("submit", params);
      let _this = this;
      if ((await _this.$checkTicketLogin()) && !_this.loadding) {
        _this.loadding = true;

        Personal(params)
          .then((res) => {
            _this.loadding = false;
            console.log(res);
            if (res.state === "success") {
              //更新缓存；
              console.log("res.data:", res.data);
              if (res.data) {
                _this.$store.dispatch("user/loginIn", res.data);
              }
              if (_this.$route.query.redirect) {
                console.log(_this.$route.query.redirect);
                _this.$router.push({
                  name: _this.$route.query.redirect,
                });
              } else {
                _this.$router.push({
                  path: "category",
                  query: { fcn: res.data.FullCardNumber },
                });
              }
            } else if (res.state == "carded") {
              Dialog.confirm({
                title: "提示",
                message:
                  "您的身份证已绑定其他账号，是否去解绑？每个证件有一次解绑机会。",
                confirmButtonText: "去解绑",
                cancelButtonText: "我再想想",
              })
                .then(() => {
                  console.log("解绑");
                  _this.unBindCard(params);
                })
                .catch((err) => {
                  console.log(err);
                });
            } else {
              Toast(res.msg);
            }
          })
          .catch((err) => {
            _this.loadding = false;
            console.log(err);
          });
      }
    },
  },
};
</script>
<style lang="scss" scoped >
.per-btn {
  width: 100%;
  text-align: center;
  display: flex;
  justify-content: space-around;
  button {
    // margin-right: 20px;
    width: 150px;
  }
}
.phelp {
  font-size: 14px;
  color: #fff;
  .txt {
    text-align: left;
    a {
      color: #fff;
      text-decoration: underline;
    }
  }
}
/deep/ .van-field__button {
  display: flex;
  margin-right: 15px;
  color: $theme-color;
  font-size: 14px;
  border-left: 1px solid #ccc;
  .reg-field-btn {
    .van-count-down {
      color: #000;
      .block {
        color: $theme-color;
      }
    }
  }
  // .van-button--default {
  //   padding: 0 10px;
  //   border: 0;
  //   border-left: 1px solid #ccc;
  //   .van-button__text {
  //     color: $theme-color;
  //     letter-spacing: 1px;
  //     font-size: 13px;
  //   }
  // }
}
/deep/ .van-field__label {
  width: 100%;
}
.van-cell::after {
  position: absolute;
  box-sizing: border-box;
  content: " ";
  pointer-events: none;
  right: 0.42667rem;
  bottom: 0;
  left: 0.42667rem;
  border-bottom: 0px;
  -webkit-transform: scaleY(0.5);
  transform: scaleY(0.5);
}
.wrapper {
  // background: #fff;
}
.block {
  font-size: 16px;
  margin-right: 2px;
}
.van-cell::after {
}
.van-count-down {
  color: #fff;
}
.van-cell {
  padding: 0px;
  margin-bottom: 20px;
  font-size: 16px;
  line-height: 28px;
}

/deep/ .van-form {
  .van-field {
    display: flex;
    flex-direction: column;
    .van-field__label {
      &::before {
        content: "*";
        color: red;
        margin-right: 5px;
      }
    }
    .van-field__value {
      flex: 1;
      .van-field__body {
        border: 1px solid #999;
        display: flex;
        border-radius: 50px;
        input,
        .van-field__control {
          flex: 1;
          padding: 5px 15px;
          border: none;
          width: 100%;
          border-radius: 50px;
          color: #323233;
        }
      }
      .van-field__error-message {
        padding-left: 15px;
        color: red;
      }
    }
  }
  // .van-field:nth-child(2) {
  //   .van-field__label {
  //     &::after {
  //       content: "（请填写参会人本人手机号）";
  //       font-size: 13px;
  //       // color: red;
  //       // text-align: center;
  //       // width: 100%;
  //       // display: flex;
  //       padding-left: 5px;
  //     }
  //   }
  // }
}
.reg-content {
  .reg-content-per {
    margin-top: 10px;
  }
}
.reg-card {
  background: #fff;
  border-radius: 12px;
  padding-top: 10px;
}
</style>
